<script setup lang="ts">
  import { computed } from 'vue';
  import { SelectableCard } from '../SelectableCard';
  import {
    firstCardClass,
    lastCardClass,
    loneCardClass,
    middleCardClass,
  } from './SelectableCardList.css';
  import type { SelectableCardListProps } from './SelectableCardList.types';

  const props = defineProps<SelectableCardListProps>();

  const filteredItems = computed(() => {
    return props.items.filter((i) => !i.hidden);
  });
</script>

<template>
  <div role="list">
    <SelectableCard
      v-for="(item, index) in filteredItems"
      :selectable="false"
      :role="item.onClick ? 'button' : 'listitem'"
      :key="item.title"
      v-bind="item"
      :small-gap="props.smallGap"
      :test-id="item.testId || `card-${index}`"
      :id="item.id || item.testId || `card-${index}`"
      @click="item.onClick || undefined"
      @middleClick="item.onMiddleClick || undefined"
      :class="{
        [firstCardClass]: filteredItems.length > 1 && index === 0,
        [middleCardClass]:
          filteredItems.length > 1 &&
          index > 0 &&
          index < filteredItems.length - 1,
        [lastCardClass]:
          filteredItems.length > 1 && index === filteredItems.length - 1,
        [loneCardClass]: filteredItems.length === 1,
      }"
    />
  </div>
</template>
